<div id="si-file-upload-{{id}}" class="si-file-upload {{styleClass}}" [class.disabled]="disabled"
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)">
  <div>
    <div *ngIf="text && !hideLabel" class="si-file-upload_label">
      <si-label [text]="text"
                [tooltipText]="tooltipText"
                [tooltipPosition]="tooltipPosition"
                [tooltipIcon]="tooltipIcon"
                [tooltipStyleClass]="tooltipStyleClass"
                [tooltipEscape]="tooltipEscape"
                [forceShowTooltipIcon]="forceShowTooltipIcon"
                (tooltipIconClick)="onClickTooltipIcon($event)"
                forId="fileInput{{id}}"
      ></si-label>
    </div>
    <div>
      <si-validation-element #validationElement
                             [formModel]="formModel"
                             [showErrorText]="!showRuleErrorOutsideIcon"
                             (errorTextChange)="validationErrorText = $event"
                             class="si-file-upload_validation"
      ></si-validation-element>
    </div>
  </div>
  <div *ngIf="subtext" class="si-file-upload_subtext mb-2">
    <span>{{subtext | translate}}</span>
  </div>
  <ng-container *ngIf="!image || !imageError; else imageTemplate">
    <div class="si-file-upload_drop d-flex flex-wrap justify-content-center align-items-center mb-2"
        *ngIf="multiple || !model.length"
        (dragenter)="onDragEnter($event)"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)">
      <i class="icon-upload si-file-upload_drop_upload mr-2"></i>
      <div class="d-flex flex-wrap justify-content-center align-items-center">
        <span>{{dragText | translate}}&nbsp;</span>
        <label for="fileInput{{id}}" class="si-file-upload_drop_file">{{browseText | translate}}</label>
        <input id="fileInput{{id}}"
              name="fileInput"
              type="file"
              class="si-file-upload_drop_input"
              [accept]="accept"
              [multiple]="multiple"
              [disabled]="disabled"
              (change)="onFileSelect($event)">
      </div>
    </div>
  </ng-container>
  <ng-template #imageTemplate>
    <div class="si-file-upload_card"
         *ngIf="multiple || !model.length"
         (dragenter)="onDragEnter($event)"
         (dragover)="onDragOver($event)"
         (drop)="onDrop($event)">
      <div [hidden]="showUploadError">
        <img [src]="image">
      </div>
      <div [hidden]="!showUploadError">
        <img [src]="imageError">
      </div>
      <div>
        <div *ngIf="showUploadError" class="si-file-upload_card_label">{{'CORE_UPLOAD_TITLE' | translate}}</div>
        <label *ngIf="!showUploadError" for="fileInput{{id}}" class="si-file-upload_card_file">{{'CORE_UPLOAD_TITLE' | translate}}</label>
        <div>{{maximumSizeText}}</div>
        <div>{{fileAcceptText}}</div>
        <div *ngIf="showUploadError" class="si-file-upload_card_error">{{'CORE_UPLOAD_ERROR' | translate}}</div>
        <label *ngIf="showUploadError" for="fileInput{{id}}" class="si-file-upload_card_file">{{'CORE_UPLOAD_TRY_AGAIN' | translate}}</label>
        <input id="fileInput{{id}}"
               name="fileInput"
               type="file"
               class="si-file-upload_card_input"
               [accept]="accept"
               [multiple]="multiple"
               [disabled]="disabled"
               (change)="onFileSelect($event)">
      </div>
    </div>
  </ng-template>
  <div siProvideParentForm>
    <input #formModel="ngModel"
           id="hiddenInputFileUpload"
           name="hiddenInputFileUpload"
           type="hidden"
           [disabled]="disabled"
           [ngModel]="model"
           siValidation="{{rule}}"
           [siValidationElement]="validationElement"
           [siValidationExternalErrorText]="validationExternalErrorText"/>
  </div>
  <p-fileUpload #pFileUpload
                [customUpload]="true"
                [showCancelButton]="false"
                [showUploadButton]="false"
                [multiple]="multiple"
                [fileLimit]="fileLimit"
                [accept]="accept"
                [maxFileSize]="maxFileSize"
                [previewWidth]="previewWidth"
                [files]="model"
                (onSelect)="onAddFile($event)">
    <ng-template *ngIf="!pTemplateFile" pTemplate="file" let-file let-i="index">
      <div class="d-flex align-items-center mb-1">
        <div class="mr-2">
          <img *ngIf="isImage(file); else icon"
               [src]="file.objectURL || file.url"
               [width]="previewWidth"
               class="si-file-upload_files_image"
               (click)="onClickImagePreview(file)"/>
          <ng-template #icon>
            <i class="icon-fileempty si-file-upload_files_icon" (click)="onClickFile(file)"></i>
          </ng-template>
        </div>
        <div class="si-file-upload_files_name mr-2" (click)="onClickFile(file)">{{file.name}}</div>
        <div class="ml-auto d-flex">
          <i class="icon-closex si-file-upload_files_remove" (click)="removeFile($event, i)"></i>
        </div>
      </div>
    </ng-template>
    <ng-template *ngIf="pTemplateFile" let-outerContext pTemplate="file">
      <ng-container *ngTemplateOutlet="pTemplateFile; context: {$implicit: outerContext}"></ng-container>
    </ng-template>
  </p-fileUpload>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
